import { gql } from '@apollo/client'

export const GET_ALL_PROCESSES_SUBCATEGORIES_CHILDREN_BY_PROCESS_SUBCATEGORY_ID = gql`
    query GetAllProcessesSubCategoriesChildrenByProcessSubCategoryId($processSubCategoryId: Int!) {
        getAllProcessesSubCategoriesChildrenByProcessSubCategoryId(process_sub_category_id: $processSubCategoryId) {
            id
            name
            description
        }
    }
`
